// Tiny in-app + cross-tab event bus. Same-tab listeners fire via a shared
// EventTarget, and cross-tab listeners fire via BroadcastChannel. Modules
// call `emit("kind", payload)` on mutations; consumers call `subscribe("kind", cb)`.
const CHANNEL = "bidforge-events";
const bus = new EventTarget();

let ch = null;
if (typeof window !== "undefined" && typeof window.BroadcastChannel !== "undefined") {
  try {
    ch = new window.BroadcastChannel(CHANNEL);
  } catch {
    ch = null;
  }
}

export function emit(kind, data) {
  try {
    ch?.postMessage({ kind, data });
  } catch {
    /* no-op */
  }
  bus.dispatchEvent(new CustomEvent(kind, { detail: data }));
}

export function subscribe(kind, handler) {
  const localHandler = (e) => handler(e.detail);
  bus.addEventListener(kind, localHandler);
  const chHandler = (e) => {
    if (e?.data?.kind === kind) handler(e.data.data);
  };
  ch?.addEventListener("message", chHandler);
  return () => {
    bus.removeEventListener(kind, localHandler);
    ch?.removeEventListener("message", chHandler);
  };
}
